<template>
  <div class="labeled-policyholder-selector">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <PolicyholderSelector
      ref="policyholderSelector"
      :id="inputId"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :is-loading="isLoading"
      :show-icon="showIcon"
      :empty-state-text="emptyStateText"
      :policyholder="policyholder"
      :policyholder-type="policyholderType"
      :policyholders-list="policyholdersList"
      :mask="mask"
      :selected-display-key="selectedDisplayKey"
      :auto-open-on-update-list="autoOpenOnUpdateList"
      :auto-select-single="autoSelectSingle"
      :validation-errors="validationErrors"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </PolicyholderSelector>
  </div>
</template>

<script>
import PolicyholderSelector from '../policyholder-selector';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: ''
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    policyholder: {
      type: [String, Number, null],
      default: null,
    },
    policyholderType: {
      type: String,
      default: 'natural',
      validation: (value) => ['natural', 'legal', 'beneficiary'].includes(value),
    },
    policyholdersList: {
      type: Array,
      default: () => [],
    },
    mask: {
      type: [String, Function, Boolean],
      default: null
    },
    selectedDisplayKey: {
      type: String,
      default: null,
      validator: (value) => ['fullName', 'taxNumber', null].includes(value),
    },
    autoOpenOnUpdateList: {
      type: Boolean,
      default: false,
    },
    autoSelectSingle: {
      type: Boolean,
      default: true,
    },
    validationErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId:  `policyholder-selector-${this.generateRandomId()}`
    };
  },
  components: { InputLabel, PolicyholderSelector },
  computed: {
    getPolicyholderSelector() {
      return this.$refs.policyholderSelector;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, olValue) {
      this.$emit('beforeChange', newValue, olValue);
    }
  },
};
</script>
